"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var validate_exports = {};
__export(validate_exports, {
  assertGetImageOptions: () => assertGetImageOptions,
  assertGetStringOptions: () => assertGetStringOptions,
  assertListener: () => assertListener,
  assertSetImage: () => assertSetImage,
  assertSetStringOptions: () => assertSetStringOptions,
  assertSetStringText: () => assertSetStringText,
  assertSetUrl: () => assertSetUrl
});
module.exports = __toCommonJS(validate_exports);
function assertSetStringText(text) {
  if (typeof text !== "string") {
    throw new Error("Clipboard.setString: text must be a string");
  }
}
function assertSetStringOptions(options, verb) {
  if (options === void 0) return;
  if (!options || typeof options !== "object") {
    throw new Error(`Clipboard.${verb}: options must be an object`);
  }
  if (options.inputFormat !== void 0 && options.inputFormat !== "plainText" && options.inputFormat !== "html") {
    throw new Error(`Clipboard.${verb}: inputFormat must be 'plainText' or 'html'`);
  }
}
function assertGetStringOptions(options, verb) {
  if (options === void 0) return;
  if (!options || typeof options !== "object") {
    throw new Error(`Clipboard.${verb}: options must be an object`);
  }
  if (options.preferredFormat !== void 0 && options.preferredFormat !== "plainText" && options.preferredFormat !== "html") {
    throw new Error(`Clipboard.${verb}: preferredFormat must be 'plainText' or 'html'`);
  }
}
function assertSetImage(base64Image) {
  if (typeof base64Image !== "string" || base64Image.length === 0) {
    throw new Error("Clipboard.setImage: base64Image must be a non-empty string");
  }
}
function assertGetImageOptions(options) {
  if (!options || typeof options !== "object") {
    throw new Error("Clipboard.getImage: options must be an object");
  }
  if (options.format !== "png" && options.format !== "jpeg") {
    throw new Error(`Clipboard.getImage: format must be 'png' or 'jpeg'`);
  }
  if (options.jpegQuality !== void 0) {
    if (typeof options.jpegQuality !== "number" || Number.isNaN(options.jpegQuality) || options.jpegQuality < 0 || options.jpegQuality > 1) {
      throw new Error("Clipboard.getImage: jpegQuality must be a number from 0 to 1");
    }
  }
}
function assertSetUrl(url) {
  if (typeof url !== "string" || url.length === 0) {
    throw new Error("Clipboard.setUrl: url must be a non-empty string");
  }
}
function assertListener(listener) {
  if (typeof listener !== "function") {
    throw new Error("Clipboard.addListener: listener must be a function");
  }
}
//# sourceMappingURL=validate.js.map
